import { ReviewsWidget } from "@/components/sections/ReviewsWidget";

export function Reviews({ limit, widgetId }: { limit?: number; widgetId?: string }) {
  return <ReviewsWidget limit={limit} widgetId={widgetId} />;
}

